import { createContext, useContext } from 'react'
import { type NavContextValue } from 'gin-and-tonic/containers/nav/utils/nav.types'

export const NavContext = createContext<NavContextValue>(null)

export const useNavContext = () => useContext(NavContext)
